import { render, staticRenderFns } from "./TractPtFormDownload.vue?vue&type=template&id=653aaff4&"
import script from "./TractPtFormDownload.vue?vue&type=script&lang=js&"
export * from "./TractPtFormDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports